import { render } from "./form-textarray.vue?vue&type=template&id=0118087f"
import script from "./form-textarray.vue?vue&type=script&lang=js"
export * from "./form-textarray.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__